AppTabs.createTab( {
name: 'outside-labs',
icon: 'list-alt',
text: 'Outside Labs',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-outside-labs',

		readTableName: 	'tblOutsideLabs',
		editTableName: 	'tblOutsideLabs',
		primaryKey: 	'OutsideLabID',

		canSort:			false,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		fields: [
			{
				label: 		'Name',
				columnName: 'LabName',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'Certification ID',
				columnName: 'LabCertificationID',
				isEditable: true,
			},
			{
				label: 		'Initials',
				columnName: 'LabInitials',
				isEditable: true,
			},
		],

	} );
}

} );
